import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "./api";

const AuthCtx = createContext({ user: undefined, setUser: () => {} });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined);
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(null));
  }, []);
  return <AuthCtx.Provider value={{ user, setUser }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

export const RequireRole = ({ role, children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-paper">
        <p className="text-brand-navy font-semibold">Loading…</p>
      </div>
    );
  }
  if (!user || user.role !== role) {
    const loginPath = { admin: "/portal/login", caregiver: "/caregiver/login", patient: "/patient/login" }[role] || "/portal/login";
    return <Navigate to={loginPath} replace state={{ from: location }} />;
  }
  return children;
};
